/* ==========================================================================
   DIDO — Size Guide popup (11 Oct 2026)
   Native <dialog> (focus stays inside, Esc closes), backdrop click closes,
   tabs with arrow keys, highlights the selected size, draws the measuring
   diagrams in the store's colours. No dependencies.
   Body tab: owner's illustration with live SVG tape loops that animate.
   12 Oct: highlight state rewritten (one state per pane: tap > focus > hover,
   applied only when the key changes) to fix lag/flicker after tapping a mark
   and then using the step list.
   ========================================================================== */
(function () {
  'use strict';
  if (window.DIDO_SIZE_GUIDE) return;
  window.DIDO_SIZE_GUIDE = true;

  var NS = 'http://www.w3.org/2000/svg';
  var SELF = (document.currentScript && document.currentScript.src) ||
    ((document.querySelector('script[src*="size-guide.js"]') || {}).src || '');
  function asset(name) { return SELF.replace(/size-guide\.js(\?.*)?$/, name); }

  var D = {
    jacket: {
      shape: ['M128 38 L95 50 L35 258 L66 266 L96 118 L92 300 L208 300 L204 118 L234 266 L265 258 L205 50 L172 38 Q150 47 128 38 Z'],
      detail: ['M128 38 L138 66 L130 74 L150 150 M172 38 L162 66 L170 74 L150 150', 'M150 150 L150 300',
        'M106 238 L134 238 M166 238 L194 238', 'M40 240 L68 248 M260 240 L232 248'],
      buttons: [[156, 180, 2.6], [156, 214, 2.6], [156, 248, 2.6]],
      marks: {
        shoulder: [97, 52, 203, 52, 112, 52],
        bust: [96, 128, 204, 128, 112, 128],
        waist: [94, 190, 206, 190, 110, 190],
        hip: [93, 268, 207, 268, 110, 268],
        length: [186, 42, 186, 300, 186, 284],
        sleeve: [214, 47, 274, 255, 244, 151],
        bicep: [72, 134, 94, 134, 56, 134],
        cuff: [35, 264, 66, 272, 46, 288]
      }
    },
    dress: {
      shape: ['M130 36 L108 46 L54 226 L78 232 L108 104 L112 140 L80 330 L220 330 L188 140 L192 104 L222 232 L246 226 L192 46 L170 36 Q150 52 130 36 Z'],
      detail: ['M112 140 Q150 146 188 140', 'M58 214 L80 220 M242 214 L220 220'],
      marks: {
        shoulder: [110, 50, 190, 50, 124, 50],
        bust: [108, 112, 192, 112, 123, 112],
        waist: [113, 146, 187, 146, 127, 146],
        hip: [104, 196, 196, 196, 119, 196],
        length: [168, 42, 168, 330, 168, 312],
        sleeve: [201, 43, 255, 223, 228, 133],
        bicep: [88, 116, 105, 116, 72, 116],
        cuff: [54, 232, 78, 238, 58, 254]
      }
    },
    'dress-sleeveless': {
      shape: ['M130 36 L112 44 Q102 72 108 104 L112 140 L80 330 L220 330 L188 140 L192 104 Q198 72 188 44 L170 36 Q150 52 130 36 Z'],
      detail: ['M112 140 Q150 146 188 140'],
      marks: {
        shoulder: [113, 46, 187, 46, 126, 46],
        bust: [107, 108, 193, 108, 122, 108],
        waist: [113, 146, 187, 146, 127, 146],
        hip: [104, 196, 196, 196, 119, 196],
        length: [168, 42, 168, 330, 168, 312]
      }
    },
    top: {
      shape: ['M128 40 L100 50 L40 238 L66 248 L98 116 L98 250 L202 250 L202 116 L234 248 L260 238 L200 50 L172 40 Q150 58 128 40 Z'],
      detail: ['M98 236 L202 236', 'M45 222 L70 231 M255 222 L230 231', 'M134 44 Q150 60 166 44'],
      marks: {
        shoulder: [102, 54, 198, 54, 116, 54],
        bust: [99, 128, 201, 128, 114, 128],
        waist: [98, 184, 202, 184, 114, 184],
        hip: [98, 226, 202, 226, 114, 226],
        length: [178, 46, 178, 250, 178, 216],
        sleeve: [209, 47, 269, 235, 239, 141],
        bicep: [76, 128, 95, 128, 60, 128],
        cuff: [40, 243, 66, 253, 44, 266]
      }
    },
    cardigan: {
      shape: ['M132 32 L86 52 L44 230 L70 238 L94 124 L90 340 L210 340 L206 124 L230 238 L256 230 L214 52 L168 32 Q150 40 132 32 Z'],
      detail: ['M132 32 L144 340 M168 32 L156 340', 'M94 124 Q91 88 86 52 M206 124 Q209 88 214 52',
        'M102 262 L130 262 L130 296 L102 296 Z M198 262 L170 262 L170 296 L198 296 Z', 'M48 216 L72 224 M252 216 L228 224'],
      marks: {
        shoulder: [88, 56, 212, 56, 104, 56],
        bust: [94, 136, 206, 136, 109, 136],
        waist: [92, 200, 208, 200, 108, 200],
        length: [190, 38, 190, 340, 190, 322],
        sleeve: [223, 50, 265, 228, 244, 139],
        bicep: [74, 132, 93, 132, 58, 132],
        cuff: [44, 235, 70, 243, 46, 256]
      }
    },
    set: {
      shape: ['M130 34 L104 44 L52 196 L76 204 L104 104 L102 168 L198 168 L196 104 L224 204 L248 196 L196 44 L170 34 Q150 50 130 34 Z',
        'M114 186 L186 186 L188 200 L212 318 L88 318 L112 200 Z'],
      detail: ['M102 156 L198 156', 'M112 200 L188 200', 'M131 200 L121 318 M150 200 L150 318 M169 200 L179 318', 'M56 184 L78 191 M244 184 L222 191'],
      marks: {
        shoulder: [106, 48, 194, 48, 120, 48],
        bust: [104, 116, 196, 116, 118, 116],
        waist: [113, 193, 187, 193, 126, 193],
        hip: [104, 242, 196, 242, 117, 242],
        length: [[172, 38, 172, 168, 172, 142], [204, 186, 226, 318, 226, 300]],
        sleeve: [204, 41, 256, 193, 230, 117],
        bicep: [81, 112, 101, 112, 66, 112],
        cuff: [52, 200, 76, 208, 54, 220]
      }
    },
    body: {
      img: 'size-guide-body.webp',
      w: 622, h: 1022,
      fade: 1,
      badgeX: 575, badgeR: 19,
      marks: {
        bust: { e: [307, 417.6, 121, 19] },
        waist: { e: [307.5, 568.7, 74, 13] },
        hip: { e: [308, 764.2, 151, 21] }
      }
    }
  };

  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function marker(g, x, y, n) {
    el('circle', { cx: x, cy: y, r: 10, class: 'sg-m-ripple' }, g);
    var b = el('g', { class: 'sg-m-badge' }, g);
    el('circle', { cx: x, cy: y, r: 10, class: 'sg-m-dot' }, b);
    el('text', { x: x, y: y + 0.5, class: 'sg-m-num' }, b).textContent = n;
  }
  function measureLine(g, m, n) {
    var x1 = m[0], y1 = m[1], x2 = m[2], y2 = m[3];
    var dx = x2 - x1, dy = y2 - y1, len = Math.sqrt(dx * dx + dy * dy) || 1;
    var px = -dy / len * 4, py = dx / len * 4;
    el('path', { class: 'sg-m-line', d: 'M' + x1 + ' ' + y1 + ' L' + x2 + ' ' + y2 +
      ' M' + (x1 + px) + ' ' + (y1 + py) + ' L' + (x1 - px) + ' ' + (y1 - py) +
      ' M' + (x2 + px) + ' ' + (y2 + py) + ' L' + (x2 - px) + ' ' + (y2 - py) }, g);
    marker(g, m[4], m[5], n);
  }

  function tapeMark(g, fam, m, n, i) {
    var cx = m.e[0], cy = m.e[1], rx = m.e[2], ry = m.e[3];
    var L = 'M' + (cx - rx) + ' ' + cy, R = (cx + rx) + ' ' + cy, A = ' A' + rx + ' ' + ry + ' 0 0 ';
    var bx = fam.badgeX, br = fam.badgeR;
    g.setAttribute('style', '--i:' + i);
    el('path', { class: 'sg-b-hit', d: L + A + '1 ' + R + A + '1 ' + (cx - rx) + ' ' + cy + ' M' + (cx + rx) + ' ' + cy + ' L' + bx + ' ' + cy }, g);
    el('path', { class: 'sg-b-glow', d: L + A + '0 ' + R, pathLength: 1 }, g);
    el('path', { class: 'sg-b-back', d: L + A + '1 ' + R }, g);
    el('path', { class: 'sg-b-front', d: L + A + '0 ' + R, pathLength: 1 }, g);
    el('path', { class: 'sg-b-lead', d: 'M' + (cx + rx + 9) + ' ' + cy + ' L' + (bx - br - 7) + ' ' + cy }, g);
    el('circle', { class: 'sg-b-tip', cx: cx + rx, cy: cy, r: 3.4 }, g);
    el('circle', { class: 'sg-b-ripple', cx: bx, cy: cy, r: br }, g);
    el('circle', { class: 'sg-b-ripple', cx: bx, cy: cy, r: br }, g);
    var b = el('g', { class: 'sg-b-badge' }, g);
    el('circle', { class: 'sg-b-dot', cx: bx, cy: cy, r: br }, b);
    el('circle', { class: 'sg-b-ring', cx: bx, cy: cy, r: br - 4 }, b);
    el('text', { class: 'sg-b-num', x: bx, y: cy + 1 }, b).textContent = n;
  }

  function draw(svg) {
    var fam = D[svg.getAttribute('data-sg-diagram')] || D.dress;
    var pane = svg.closest('[data-sg-pane]');
    var steps = pane ? pane.querySelectorAll('[data-sg-step]') : [];
    while (svg.firstChild) svg.removeChild(svg.firstChild);

    if (fam.img) {
      svg.setAttribute('viewBox', '0 0 ' + fam.w + ' ' + fam.h);
      if (svg.parentNode) svg.parentNode.classList.add('sg__figure--body');
      var fid = 'sgFade' + Math.random().toString(36).slice(2, 8);
      var defs = el('defs', {}, svg);
      var grad = el('linearGradient', { id: fid + 'g', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      el('stop', { offset: Math.min(fam.fade, 0.999), 'stop-color': '#fff' }, grad);
      el('stop', { offset: 1, 'stop-color': '#000' }, grad);
      var mask = el('mask', { id: fid, maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: fam.w, height: fam.h }, defs);
      el('rect', { x: 0, y: 0, width: fam.w, height: fam.h, fill: 'url(#' + fid + 'g)' }, mask);
      el('image', { x: 0, y: 0, width: fam.w, height: fam.h, href: asset(fam.img), mask: 'url(#' + fid + ')' }, svg);
    } else {
      (fam.shape || []).forEach(function (d) { el('path', { d: d, class: 'sg-d-shape' }, svg); });
      (fam.detail || []).forEach(function (d) { el('path', { d: d, class: 'sg-d-detail' }, svg); });
      (fam.buttons || []).forEach(function (b) { el('circle', { cx: b[0], cy: b[1], r: b[2], class: 'sg-d-button' }, svg); });
    }

    Array.prototype.forEach.call(steps, function (li, i) {
      var key = li.getAttribute('data-sg-step');
      var m = fam.marks[key];
      if (!m) return;
      var n = li.getAttribute('data-sg-n');
      if (m.e) { tapeMark(el('g', { class: 'sg-m sg-b', 'data-sg-mark': key }, svg), fam, m, n, i); return; }
      var g = el('g', { class: 'sg-m', 'data-sg-mark': key }, svg);
      if (Array.isArray(m[0])) m.forEach(function (one) { measureLine(g, one, n); });
      else measureLine(g, m, n);
    });
  }

  function norm(s) {
    s = String(s || '').toUpperCase().replace(/\s+/g, '');
    if (s === 'XXL') return '2XL';
    if (s === 'ONESIZE' || s === 'FREESIZE') return 'FREESIZE';
    return s;
  }
  function currentSize() {
    var groups = document.querySelectorAll('[data-option-index]');
    for (var i = 0; i < groups.length; i++) {
      var name = (groups[i].getAttribute('data-option-name') || '').toLowerCase();
      if (name.indexOf('size') === -1) continue;
      var c = groups[i].querySelector('input:checked');
      if (c) return c.value;
      var opts = groups[i].querySelectorAll('input[type="radio"]');
      if (opts.length === 1) return opts[0].value;
      return null;
    }
    return null;
  }
  function markSize(dialog) {
    var size = norm(currentSize());
    dialog.querySelectorAll('tbody').forEach(function (tb) {
      var rows = tb.querySelectorAll('tr[data-sg-size]');
      var hits = 0;
      rows.forEach(function (tr) {
        var on = !!size && norm(tr.getAttribute('data-sg-size')) === size;
        tr.classList.toggle('is-selected', on);
        if (on) hits++;
      });
      if (hits > 1 && hits === rows.length) rows.forEach(function (tr) { tr.classList.remove('is-selected'); });
    });
  }

  function setup(dialog) {
    if (dialog.__sg) return;
    dialog.__sg = true;
    var tabs = Array.prototype.slice.call(dialog.querySelectorAll('[data-sg-tab]'));
    var panes = Array.prototype.slice.call(dialog.querySelectorAll('[data-sg-pane]'));
    var body = dialog.querySelector('.sg__body');
    var drawn = false;

    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panes[j].hidden = !on;
      });
      if (focus && tabs[i]) tabs[i].focus();
      if (body) body.scrollTop = 0;
      var fig = panes[i] && panes[i].querySelector('.sg__figure--body .sg__diagram');
      if (fig) {
        fig.classList.remove('sg-in');
        void fig.getBoundingClientRect();
        fig.classList.add('sg-in');
        clearTimeout(fig.__inT);
        fig.__inT = setTimeout(function () { fig.classList.remove('sg-in'); }, 2200);
      }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var rtl = getComputedStyle(dialog).direction === 'rtl';
        var next = { ArrowRight: rtl ? -1 : 1, ArrowLeft: rtl ? 1 : -1, Home: -i, End: tabs.length - 1 - i }[e.key];
        if (next === undefined) return;
        e.preventDefault();
        select((i + next + tabs.length) % tabs.length, true);
      });
    });

    /* Highlight state: one per pane (tap beats focus beats hover), painted only when the key changes */
    function paint(pane, key) {
      if (pane.__hlKey === key) return;
      pane.__hlKey = key;
      var svg = pane.querySelector('.sg__diagram');
      pane.querySelectorAll('[data-sg-step]').forEach(function (s) { s.classList.toggle('is-hl', !!key && s.getAttribute('data-sg-step') === key); });
      if (svg) {
        svg.classList.toggle('has-hl', !!key);
        svg.querySelectorAll('.sg-m').forEach(function (g) { g.classList.toggle('is-hl', !!key && g.getAttribute('data-sg-mark') === key); });
      }
      pane.querySelectorAll('[data-sg-col]').forEach(function (c) { c.classList.toggle('is-col-hl', !!key && c.getAttribute('data-sg-col') === key); });
    }
    function st(pane) { return pane.__hl || (pane.__hl = { hover: null, focus: null, tap: null }); }
    function set(pane, field, key) { if (!pane) return; var s = st(pane); s[field] = key; paint(pane, s.tap || s.focus || s.hover || null); }
    function paneOf(n) { return n.closest('[data-sg-pane]'); }
    function toggleTap(pane, key) { if (!pane) return; set(pane, 'tap', st(pane).tap === key ? null : key); }

    dialog.querySelectorAll('[data-sg-step]').forEach(function (li) {
      var key = li.getAttribute('data-sg-step');
      li.addEventListener('mouseenter', function () { set(paneOf(li), 'hover', key); });
      li.addEventListener('mouseleave', function () { var p = paneOf(li); if (st(p).hover === key) set(p, 'hover', null); });
      li.addEventListener('focus', function () { set(paneOf(li), 'focus', key); });
      li.addEventListener('blur', function () { var p = paneOf(li); if (st(p).focus === key) set(p, 'focus', null); });
      li.addEventListener('click', function () { var p = paneOf(li); if (p && p.querySelector('.sg-b')) toggleTap(p, key); });
    });
    dialog.addEventListener('mouseover', function (e) {
      var mk = e.target.closest && e.target.closest('.sg-b');
      if (!mk || mk.contains(e.relatedTarget)) return;
      set(paneOf(mk), 'hover', mk.getAttribute('data-sg-mark'));
    });
    dialog.addEventListener('mouseout', function (e) {
      var mk = e.target.closest && e.target.closest('.sg-b');
      if (!mk || mk.contains(e.relatedTarget)) return;
      var p = paneOf(mk); if (p && st(p).hover === mk.getAttribute('data-sg-mark')) set(p, 'hover', null);
    });
    dialog.addEventListener('click', function (e) {
      var mk = e.target.closest && e.target.closest('.sg-b');
      if (!mk) return;
      toggleTap(paneOf(mk), mk.getAttribute('data-sg-mark'));
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-sg-close]')) dialog.close();
    });
    dialog.addEventListener('close', function () {
      panes.forEach(function (p) { p.__hl = null; paint(p, null); });
      document.documentElement.classList.remove('sg-lock');
      if (dialog.__opener) dialog.__opener.focus();
    });

    dialog.__open = function (opener) {
      if (!drawn) { dialog.querySelectorAll('[data-sg-diagram]').forEach(draw); drawn = true; }
      markSize(dialog);
      select(0);
      dialog.__opener = opener || null;
      document.documentElement.classList.add('sg-lock');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      var close = dialog.querySelector('[data-sg-close]');
      if (close) close.focus();
    };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sg-open]');
    if (!btn) return;
    e.preventDefault();
    var dialog = document.getElementById(btn.getAttribute('data-sg-open'));
    if (!dialog) return;
    setup(dialog);
    dialog.__open(btn);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.closest('[data-option-index]')) return;
    document.querySelectorAll('[data-size-guide]').forEach(markSize);
  });
})();
